import Analytics from '../../../../../../../../../analytics';

export const faOnRecentViewedSectionLoad = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.SYSTEM_GENERATED,
    event_name: Analytics.EVENT_NAMES.CONTENT_VIEWED,
    event_value: `RVS_Section`,
    isXdmEvent: false,
  });
};
export const faOnRecentViewedCardClick = ({ cardIndex, packageId, sectionIndex }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: `RVS_card_${cardIndex}_${packageId}_${sectionIndex}`,
  });
};
export const faOnRecentViewedCardView = ({ cardIndex, packageId, sectionIndex }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.SYSTEM_GENERATED,
    event_name: Analytics.EVENT_NAMES.CONTENT_VIEWED,
    event_value: `RVS_card_${cardIndex}_${packageId}_${sectionIndex}`,
    isXdmEvent: false,
  });
};
